import { DSButton } from "@components/design-system/molecules";

export default function WizardStep({
  title,
  description,
  children,
  onNext,
  onBack,
  nextLabel = "Next",
  backLabel = "Back",
  nextDisabled = false,
  hideNext = false,
  hideBack = false,
  footerActions,
  dataTestId,
}) {
  return (
    <div
      className="flex flex-col gap-md w-full"
      data-testid={dataTestId}
    >
      <div className="flex flex-col gap-xs">
        <h3 className="text-xl font-semibold text-primary">
          {title}
        </h3>
        {description && (
          <p className="text-sm text-secondary">{description}</p>
        )}
      </div>

      <div className="flex-1">{children}</div>

      <div className="flex justify-between items-center pt-md">
        <div>
          {!hideBack && onBack && (
            <DSButton
              variant="secondary"
              onClick={onBack}
              size="lg"
              type="button"
              dataTestId={`${dataTestId}-back-btn`}
            >
              {backLabel}
            </DSButton>
          )}
        </div>
        <div className="flex gap-sm">
          {footerActions
            ? footerActions
            : !hideNext &&
              onNext && (
                <DSButton
                  variant="primary"
                  size="lg"
                  onClick={onNext}
                  disabled={nextDisabled}
                  type="button"
                  dataTestId={`${dataTestId}-next-btn`}
                >
                  {nextLabel} →
                </DSButton>
              )}
        </div>
      </div>
    </div>
  );
}
